import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import ProviderManager from '../../../../provider/providerManager';
import lodash from 'lodash';

export const verifyPhone = createAsyncThunk('otpVerifyPhone/verifyPhone', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('createOtp', [data]);
    return result;
  } catch (error) {
    return error;
  }
});

const initialState = {
  form: {
    phone: '',
    id: '',
    valid: '',
    errors: {
      phone: '',
    },
    rules: {},
  },
};

const otpVerifyPhoneSlice = createSlice({
  name: 'otpVerifyPhone',
  initialState,
  reducers: {
    reset: () => initialState,
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const form = validateFields(lodash.cloneDeep(payload.form));
        if (!payload.isDisplayIdentity && form.errors.id != '' && form.errors.phone == '') {
          form.valid = true;
        }
        return {payload: form};
      },
    },
    clearIsValid: {
      reducer(state, action) {
        const form = {...state.form}; // your state form obj
        form.valid = '';
        state['form'] = form;
      },
    },
    clearPhone: {
      reducer(state, action) {
        const form = {...state.form}; // your state form obj
        form.phone = '';
        state['form'] = form;
      },
    },
    blurHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);

        if (form.phone.length > 10) {
          form.phone = form.phone.slice(0, 10);
          form.errors.phone = '';
        }

        let isNumber = /^\d+$/.test(form.phone);

        if (form.phone.length < 10 && isNumber) form.errors.phone = '';

        return {payload: validate};
      },
    },
    setFormDetails: (state, action) => {
      state.form.phone = action.payload.phone;
      state.form.id = action.payload.id;
    },
  },
  extraReducers: {
    [verifyPhone.fulfilled]: (state, action) => {
      state.exist = action.payload;
    },
  },
});

export const {changeHandler, blurHandler, validateHandler, clearIsValid, reset, clearPhone, reportAnalytics, setFormDetails} =
  otpVerifyPhoneSlice.actions;

export default otpVerifyPhoneSlice.reducer;
